$(document).ready(function () {
    $.validator.addMethod("IP4Checker", function (value, element) {
        return this.optional(element) || /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([0-9]|[12]\d|3[0-2]))?$/i.test(value);
    });

    $.validator.addMethod("IP4CheckerWithMask", function (value, element) {
        return this.optional(element) || /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.((25[0-5]|2[0-4]\d|[01]?\d\d?)|\*)\.((25[0-5]|2[0-4]\d|[01]?\d\d?)|\*)$/i.test(value);
    });

    const options = {
        rules: {
            ip: {
                IP4Checker: true
            }
        },
        messages: {
            ip: translate['Please enter a valid IPv4 Address']
        },
        invalidHandler: (event, validator) => {
            $('#edit-security-settings-form').addClass('has-error')
        },
        errorClass: 'error help-block'
    }
    const $edit = $('#edit-security-settings-form [name="allowed_ips[]"]');
    if ($edit.length) {
        options.rules.ip = { IP4CheckerWithMask: true }
        if ($edit.prop('required')) {
            options.rules['allowed_ips[]'] = 'required'
            //Need for validation hidden elements
            options.ignore = []
            options.messages['allowed_ips[]'] = { required: translate['This field is required']}
        }
    }
    const validatorIp = $('#edit-security-settings-form').validate(options);

    $('#edit-security-settings-form > fieldset > section > div > input[type="text"]')
        .attr('name', 'ip')
        .attr('type', 'ip')
        .attr('id', 'ip');

    $('#api_ips,#allowed_ips').on('itemAdded', function (event) {
        var tag = event.item;
        if (!validatorIp.element("#ip")) {
            $('#api_ips,#allowed_ips').tagsinput('remove', tag);
        }
    });
});
